import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SearchExportState } from './search-export.state';

export const selectSearchExportState = createFeatureSelector<SearchExportState>('searchExport');

// Start Export selectors
export const selectStartExport = createSelector(
  selectSearchExportState,
  (state: SearchExportState) => state.startExport
);

export const selectStartExportLoading = createSelector(
  selectStartExport,
  (startExport) => startExport.isLoading
);

export const selectStartExportResult = createSelector(
  selectStartExport,
  (startExport) => startExport.result
);

export const selectStartExportError = createSelector(
  selectStartExport,
  (startExport) => startExport.error
);

// Exports list selectors
export const selectExportsState = createSelector(
  selectSearchExportState,
  (state: SearchExportState) => state.exports
);

export const selectSearchExports = createSelector(
  selectExportsState,
  (exports) => exports.items
);

export const selectSearchExportsLoading = createSelector(
  selectExportsState,
  (exports) => exports.isLoading
);

export const selectSearchExportsError = createSelector(
  selectExportsState,
  (exports) => exports.error
);

export const selectSearchExportsPagination = createSelector(
  selectExportsState,
  (exports) => exports.pagination
);

// Download selectors
export const selectDownloadState = createSelector(
  selectSearchExportState,
  (state: SearchExportState) => state.download
);

export const selectSearchExportDownloadingIds = createSelector(
  selectDownloadState,
  (download) => download.downloadingIds
);
